// extracted by mini-css-extract-plugin
module.exports = {"container":"SapqGS","wrapper":"_3Yu8TQ","logo":"_3fTX1d","message":"_3ixKCo","mobile":"_2I8mz8"};